module.exports = __webpack_public_path__ + "static/media/03.93069c4d.png";